module.exports = __webpack_public_path__ + "static/media/image-10.d7ccb405.jpg";